import { render, staticRenderFns } from "./HomeArea.vue?vue&type=template&id=6f8efbb7&scoped=true&"
import script from "./HomeArea.vue?vue&type=script&lang=js&"
export * from "./HomeArea.vue?vue&type=script&lang=js&"
import style0 from "./HomeArea.vue?vue&type=style&index=0&id=6f8efbb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8efbb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
